import React from 'react';
import { Box, Chip } from '@mui/material';
import { usePlacesFilters } from '../hooks/usePlacesFilters';

/**
 * Component displaying active filters as dismissible chips.
 */
export const FilterChips: React.FC = () => {
  const { filters, updateFilter } = usePlacesFilters();

  // Build list of active filters to display
  const activeFilters: Array<{ label: string; key: keyof typeof filters; value: any }> = [];

  if (filters.type) {
    activeFilters.push({ label: `Type: ${filters.type}`, key: 'type', value: null });
  }
  // Country and rating filters removed (not supported by backend)
  if (filters.age_category.length > 0) {
    activeFilters.push({ 
      label: `Age: ${filters.age_category.join(', ')}`, 
      key: 'age_category', 
      value: [] 
    });
  }
  // Tags are not shown as chips (only as filled state in FilterPanel)
  if (filters.kid_friendly === true) {
    activeFilters.push({ label: 'Kid Friendly', key: 'kid_friendly', value: null });
  }
  if (filters.disability_friendly === true) {
    activeFilters.push({ label: 'Disability Friendly', key: 'disability_friendly', value: null });
  }

  if (activeFilters.length === 0) {
    return null;
  }

  const handleDelete = (filter: typeof activeFilters[0]) => {
    if (filter.key === 'age_category') {
      // Clear age category
      updateFilter('age_category', []);
    } else {
      // Clear other filters
      updateFilter(filter.key, filter.value);
    }
  };

  return (
    <Box sx={{ mb: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {activeFilters.map((filter, index) => (
        <Chip
          key={`${filter.key}-${index}`}
          label={filter.label}
          onDelete={() => handleDelete(filter)}
          color="primary"
          variant="outlined"
          sx={{ minHeight: '44px' }} // 44px minimum touch target
        />
      ))}
    </Box>
  );
};
